import React from 'react';

import {
    Modal,
    Button,
    Box,
    SpaceBetween,
    Alert,
    ColumnLayout,
    Link,
} from '@amzn/awsui-components-react-v3';
import { ValidateInstructorMessages } from '../../../interfaces/validateActivityInstructorProfile';

interface ValidateInstructorQualificationsModalProps {
    visible: boolean;
    onCancel: any;
    onConfirm: any;
    instructorConflict: any;
    formValues: any;
    missingQualifications: Array<string> | null;
}

const CONFIRM_ASSIGNMENT_TEXT = 'Confirm assignment';

const ValidateInstructorQualificationsModal = ({
    onCancel,
    onConfirm,
    instructorConflict,
    visible,
    formValues,
    missingQualifications,
}: ValidateInstructorQualificationsModalProps) => {
    return (
        <Modal
            onDismiss={() => onCancel()}
            visible={visible}
            closeAriaLabel="Close modal"
            size="medium"
            data-testid={`ConfirmQualificationsModal`}
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button
                            variant="link"
                            onClick={() => onCancel()}
                            data-testid={`ConfirmQualificationsCancel`}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            data-testid={`ConfirmQualificationsConfirm`}
                            onClick={() => {
                                onConfirm();
                            }}
                        >
                            {CONFIRM_ASSIGNMENT_TEXT}
                        </Button>
                    </SpaceBetween>
                </Box>
            }
            header={CONFIRM_ASSIGNMENT_TEXT}
        >
            <Alert type="warning">
                {`${instructorConflict?.instructor?.full_name}`} does not have
                the recommended qualifications for this activity. Continue
                assigning them?
            </Alert>
            <ColumnLayout>
                <div
                    data-awsui-column-layout-root="true"
                    className="reassign-adjacent-activity"
                >
                    <span className="reassign-adjacent-activity-title">
                        Recommended qualification:
                    </span>
                    {missingQualifications &&
                        missingQualifications.map(
                            (missingQualification, index) => {
                                return (
                                    <span
                                        key={`missing-qualification-${index}`}
                                    >
                                        {(missingQualification ===
                                            'wrong_language' ||
                                            missingQualification ===
                                                ValidateInstructorMessages.QUALIFICATION_LANGUAGE) && (
                                            <span>
                                                Delivery language:{' '}
                                                {formValues.delivery_language}
                                            </span>
                                        )}
                                        {(missingQualification ===
                                            'wrong_country' ||
                                            missingQualification ===
                                                ValidateInstructorMessages.QUALIFICATION_COUNTRY) && (
                                            <span>
                                                Delivery country:{' '}
                                                {formValues.delivery_country}
                                            </span>
                                        )}
                                        {(missingQualification ===
                                            'wrong_course' ||
                                            missingQualification ===
                                                ValidateInstructorMessages.QUALIFICATION_COURSE) && (
                                            <span>
                                                Approved course:{' '}
                                                {formValues.course_name}
                                            </span>
                                        )}
                                        {missingQualification ===
                                            'instructor_status_pending' && (
                                            <span>
                                                AAI status: Not authorized
                                            </span>
                                        )}
                                        {missingQualification ===
                                            'warning_course_status' && (
                                            <span>
                                                Ineligible course status:{' '}
                                                {
                                                    instructorConflict?.instructor?.courses?.find(
                                                        (course) =>
                                                            course.name ===
                                                            formValues.course_name,
                                                    )?.status
                                                }
                                            </span>
                                        )}
                                        {missingQualification ===
                                            ValidateInstructorMessages.WEBEX_HOST_LICENSE && (
                                            <span>
                                                Active WebEx host license: This
                                                instructor does not have an
                                                active WebEx host license on
                                                awsvirtual.webex.com.{' '}
                                                <Link
                                                    href="https://issues.amazon.com/issues/create?template=91e38ad6-6a3a-42c9-a847-b204f480a1fe"
                                                    external
                                                >
                                                    Request a WebEx license
                                                </Link>{' '}
                                                before assigning them.
                                            </span>
                                        )}
                                    </span>
                                );
                            },
                        )}
                </div>
            </ColumnLayout>
        </Modal>
    );
};

export default ValidateInstructorQualificationsModal;
